import { ref, readonly } from "vue";
import axios from "axios";
import { controlPanelRoutes } from "../../router/router";

const menuItems = ref([]);
const isMenuFetched = ref(false);
const isLoading = ref(false);

let menuDataPromise = null;

export function useControlPanelMenuStore() {
  const fetchMenuData = async () => {
        if (isMenuFetched.value) return menuItems.value;

    if (menuDataPromise) return menuDataPromise;

    isLoading.value = true;

    menuDataPromise = axios
      .get("/auth-service/ui/component/list/control-panel")
      .then((response) => {
        const data = response.data;
        if (data.status === "success") {
          menuItems.value = transformMenuItems(data.menus);
          isMenuFetched.value = true;
          return menuItems.value;
        } else {
          throw new Error("Failed to fetch control panel menu data");
        }
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        isLoading.value = false;
        menuDataPromise = null;
      });

    return menuDataPromise;
  };

  const transformMenuItems = (menus) => {
    return menus.map((menu) => {
      const existingMenuItem = controlPanelRoutes.find(
        (item) => item.label === menu.name
      );
      return {
        label: menu.name,
        icon: existingMenuItem?.icon || "ri-settings-line ri-lg",
        // Generates: /control-panel/subscriptions, /control-panel/plans, etc.
        path: `/control-panel/${menu.name.replace(/\s/g, "").toLowerCase()}`,
      };
    });
  };

  return {
    menuItems: readonly(menuItems),
    isMenuFetched: readonly(isMenuFetched),
    isLoading: readonly(isLoading),
    fetchMenuData,
  };
}